import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import logo2 from "../assets/images/logo2.png";
import { Link } from "react-router-dom";
import SocialHeader from "./SocialHeader";

function Header() {
  // const NavScroll = document.getElementsByClassName(".navbar");
  const [navscroll, setNavscroll] = useState(0);
  const listenScrollEvent = () => {
    window.scrollY > 0 ? setNavscroll(true) : setNavscroll(false);
  };

  useEffect(() => {
    window.addEventListener("scroll", listenScrollEvent);

    return () => {
      window.removeEventListener("scroll", listenScrollEvent);
    };
  });
  return (
    <>
      {navscroll ? <SocialHeader /> : <SocialHeader />}
      <Navbar
        sticky="top"
        collapseOnSelect
        expand="lg"
        className="bg-white py-3"
      >
        <Container>
          <Link to={"/"}>
            <img src={logo2} alt="" />
          </Link>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="ms-auto gap-lg-4 align-items-center">
              <Link to={"/"}>Home</Link>
              <NavDropdown title="BCA" id="basic-nav-dropdown">
                <Link className="dropdown-item" to={"/semisters/first"}>
                  First Semester
                </Link>
                <Link className="dropdown-item" to={"/semisters/second"}>
                  Second Semester
                </Link>
                <Link className="dropdown-item" to={"/semisters/third"}>
                  Third Semester
                </Link>
                <Link className="dropdown-item" to={"/semisters/fourth"}>
                  Fourth Semester
                </Link>
                <Link className="dropdown-item" to={"/semisters/fifth"}>
                  Fifth Semester
                </Link>
                <Link className="dropdown-item" to={"/semisters/sixth"}>
                  Sixth Semester
                </Link>
              </NavDropdown>
              <NavDropdown title="Programs" id="basic-nav-dropdown">
                <Link className="dropdown-item" to={"/programs/c"}>
                  C
                </Link>
                <Link className="dropdown-item" to={"/programs/cpp"}>
                  C++
                </Link>
                <Link className="dropdown-item" to={"/programs/dsa"}>
                  DSA
                </Link>
                <Link className="dropdown-item" to={"/programs/java"}>
                  Java
                </Link>
                <Link className="dropdown-item" to={"/program-notes"}>
                  Nots
                </Link>
              </NavDropdown>
              <Link className="dropdown-item" to={"/ContactUs"}>
                Contact
              </Link>
              <Link className="dropdown-item" to={"/faq"}>
                FAQ
              </Link>
              <Link className="dropdown-item" to={"/about"}>
                About
              </Link>
              <Link to={"/semisters/first"}>
                <button className="nav-Button py-2 px-4 text-nowrap">
                  Click Here
                </button>
              </Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default Header;
